const getters = {
  isloading: (state) => state.show_loading,
  getGlobalClient: (state) => state.selectedGlobalClient,
};

export default getters;
